import { TAbsoluteLocale } from '@src/config/i18n.config'

import { getStandardLocale } from './i18n.utils'

const isValidLocaleFormat = (locale: string): boolean => {
  const localePattern = /^[a-z]{2}-[A-Z]{2}$/
  return localePattern.test(locale)
}

export const extractLocaleFromUrlPath = (): string | null => {
  if (typeof window === 'undefined') {
    return null
  }

  const pathSegments = window.location.pathname.split('/')
  const potentialLocale = pathSegments[1]

  if (potentialLocale?.includes('-')) {
    if (isValidLocaleFormat(potentialLocale)) {
      try {
        const localePrefix = getStandardLocale(potentialLocale as TAbsoluteLocale)
        return localePrefix
      } catch (parseError) {
        console.log('Error parsing locale from URL path:', parseError)
        return null
      }
    }
  }

  return null
}

export const getLocaleFromUrlPath = (defaultLocale: string): string => {
  const urlLocale = extractLocaleFromUrlPath()
  return urlLocale ?? defaultLocale
}
